import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "./App.css";
import "./index.css";
import { LanguageProvider } from "./context/LanguageContext";
import { AuthProvider } from "./context/AuthContext";
import { UserAuthProvider } from "./context/UserAuthContext";
import { UploadedImagesProvider } from "./hooks/useUploadedImages";
import Navbar from "./components/site/Navbar";
import Footer from "./components/site/Footer";
import WhatsAppFab from "./components/site/WhatsAppFab";
import StickyBookingBar from "./components/site/StickyBookingBar";
import ConciergeChat from "./components/site/ConciergeChat";
import HomePage from "./pages/HomePage";
import BookPage from "./pages/BookPage";
import BookingSuccessPage from "./pages/BookingSuccessPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import AuthCallbackPage from "./pages/AuthCallbackPage";
import { Toaster } from "./components/ui/sonner";

const ROUTE_TITLES = {
  "/":                "Chalet Steiermark · Landhaus — Luxus-Chalet in den steirischen Alpen",
  "/book":            "Jetzt buchen · Chalet Steiermark · Landhaus",
  "/booking/success": "Buchung bestätigt · Chalet Steiermark",
  "/admin/login":     "Admin · Chalet Steiermark",
  "/admin":           "Dashboard · Chalet Steiermark",
};

function ScrollToHash() {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    document.title = ROUTE_TITLES[pathname] || "Chalet Steiermark · Landhaus";
    if (!hash) { window.scrollTo(0, 0); return; }
    const id = hash.replace("#", "");
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 60);
  }, [hash, pathname]);
  return null;
}

function Shell() {
  return (
    <>
      <Navbar />
      <ScrollToHash />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/book" element={<BookPage />} />
        <Route path="/booking/success" element={<BookingSuccessPage />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<AdminDashboardPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
      </Routes>
      <Footer />
      <StickyBookingBar />
      <WhatsAppFab />
      <ConciergeChat />
      <Toaster position="top-center" richColors />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <UserAuthProvider>
            <UploadedImagesProvider>
              <BrowserRouter>
                <Shell />
              </BrowserRouter>
            </UploadedImagesProvider>
          </UserAuthProvider>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}
